<div class="mt-4" *ngIf="restock">
  <ol class="breadcrumb bg-white">
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" [routerLink]="['/purchase/restock']">Réassorts</button></li>
    <li class="breadcrumb-item active"><button class="btn btn-sm btn-link" disabled>{{ restock.creationDate | date: 'medium' }}</button></li>
  </ol>
</div>

<div class="pb-2 bg-white rounded shadow-sm container-fluid" *ngIf="restock">
  <div class="d-flex p-3 row text-center">
    <h5 class="col-xl-4">{{ restock.creationDate | date: 'medium' }}</h5>
    <div class="col-xl">{{ restock.details.length }} référence(s)</div>
    <div class="col-xl p-2">
      <restock-status [status]="restock.status"></restock-status>
    </div>
    <div class="col-xl-4">
      <div>Ouvert le <strong>{{ restock.creationDate | date: 'medium' }}</strong></div>
      <div *ngIf="restock.completedDate">Complété le <strong>{{ restock.completedDate | date: 'medium' }}</strong></div>
    </div>
  </div>

  <div class="pt-3 pb-3 input-group" *ngIf="restock.status == 'DRAFT'">
    <input 
      type="text" 
      class="form-control" 
      placeholder="Recherche référence" 
      (keyup)="onSearchKeyup($event)" 
      [(ngModel)]="query"
      [attr.disabled]="loading ? 'DISABLED' : null"
    />
    <div class="input-group-append">
      <button 
        class="btn btn-outline-secondary" 
        type="button" 
        (click)="search()"
        [attr.disabled]="loading ? 'DISABLED' : null"
      >
        <i [ngClass]="searchInProgress ? 'spinner-border spinner-border-sm' : 'bi bi-search'"></i>
      </button>
    </div>
  </div>

  <table class="table table-sm text-center">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th>Référence</th>
        <th>Fournisseur</th>
        <th>Prix de vente</th>
        <th>Quantité</th>
        <th>Inventaire</th>
        <th>&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let detail of restock.details">
        <td><reference-image [reference]="detail.reference"></reference-image></td>
        <td class="text-left">
          <div>
            {{ detail.reference.title }}
            <a class="ml-2" [routerLink]="['/inventory/reference', detail.reference.isbn]" target="_blank">
              <i class="bi bi-card-heading"></i>
            </a>
          </div>
          <div>{{ detail.reference.isbn }}</div>
          <div>{{ detail.reference.publisher }}</div>
        </td>
        <td>{{ detail.reference.supplierReferences[0].supplier.name }}</td>
        <td>{{ detail.reference.supplierReferences[0].retailPrice / 100 | number:'1.2-2' }} $</td>
        <td>
          <input 
            type="number" 
            min="1" 
            max="999" 
            class="form-control text-center align-self-center"
            [attr.disabled]="restock.status != 'DRAFT' || loading ? 'DISABLED' : null"
            [(ngModel)]="detail.quantity" 
            (ngModelChange)="updateQuantity(detail)" 
          />
        </td>
        <td>
          <span 
            class="badge badge-secondary" 
            [class.badge-danger]="detail.reference.inventory <= 0"
            [class.badge-primary]="detail.reference.inventory == 1"
            [class.badge-success]="detail.reference.inventory > 1"
          >{{ detail.reference.inventory }}</span>
        </td>
        <td>
          <button class="btn btn-sm btn-outline-secondary" (click)="removeDetail(detail)"><span class="bi bi-trash"></span></button>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="p-3 d-flex" *ngIf="restock.status == 'DRAFT'">

    <ng-container *ngIf="processing">
      <button class="btn btn-sm btn-success ml-auto" disabled="DISABLED">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Chargement...
      </button>
    </ng-container>
    <ng-container *ngIf="!processing">
      <button class="btn btn-sm btn-success ml-auto" (click)="completeRestock()" [attr.disabled]="restock.details.length  == 0 || loading ? 'DISABLED' : null">
        Générer les commandes
      </button>
    </ng-container>
  </div>
</div>